<template>
    <BModal 
        :title="video.title"
        size="lg"
        class="video-modal"
        v-model="showModal"
        centered
        hide-footer
        hide-header
        v-on:hide="stopVideo"
        v-on:hidden="hiddenHandler"
    >
        <div class="close-video" @click="showModal = !showModal"><img src="~public@/images/close_btn.png" width="24" height="24" /></div>
        <div class="embed-responsive embed-responsive-16by9">
            <iframe
                class="embed-responsive-item"
                :src="url"
                allowfullscreen
                id="video-iframe"
            ></iframe>
        </div>
    </BModal>
</template>

<style lang="scss">
@import "../../../sass/layout/video-modal";
</style>

<script>
    export default {
        props: ['video', 'value'],
        computed: {
            url: function(){
                if (this.video.url) {
                    return 'https://www.youtube.com/embed/'+this.video.url.split('v=')[1]+'?ecver=2&modestbranding=1&autoplay=0&showinfo=0&enablejsapi=1&rel=0';
                }
                if (this.video.assessmentURL) {
                    return this.video.assessmentURL
                }
            },
            showModal: {
                get: function () {
                    return this.value
                },
                set: function (newValue) {
                    this.$emit('input', newValue)
                }
            }
        },
        methods: {
            stopVideo() {
                document.getElementById('video-iframe').contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            },
            hiddenHandler() {
                this.$emit('input', false);
            }
        }
    }
</script>